import{jsx as _jsx}from"react/jsx-runtime";import{create}from"zustand";import TextWrapper from"./TextWrapper.js";/** A hook to manage translations. *//**
	 * Get a translation as a string. This is a shorthand for
	 * getTranslationString.
	 *
	 * @param key The key of the translation.
	 *//**
	 * Get a translation as a React element.
	 *
	 * @param key The key of the translation.
	 * @returns The translation.
	 *//**
	 * Get a translation as a string.
	 *
	 * @param key The key of the translation.
	 * @returns The translation.
	 *//**
	 * Set the translations.
	 *
	 * @param translations The translations to set.
	 *//**
	 * The stored translations. Please use getTranslation or getTranslationString
	 * instead of accessing this directly.
	 */export const useTranslations=create((set,get)=>({_e:key=>get().translations[key]||"",getTranslation:key=>/*#__PURE__*/_jsx(TextWrapper,{markdownContent:get().translations[key]||""}),getTranslationString:key=>get().translations[key]||"",setTranslations:translations=>{set({translations})},translations:{}}));